<template>
	<div >
		<section class="row no-gutters">
		<!-- tabla de servicios adicionales -->
		<template v-if="arrayAdditionalServices.length > 0">
			<div
				class="col-sm-12 col-lg-6 p-2"
				v-for="(item, index) in arrayAdditionalServices"
				:key="index">
				<!-- item card -->
				<CardAdditional
					:item="item"
					@showConfirmQuantity="selectedAddtService(index)"
					@showDetails="showDetails(item)"/>
			</div>
		</template>

		<div v-else  class="d-flex w-100 text-center flex-column justify-content-center p-2">
			<h3>SIN RESULTADOS</h3>
			<p>No existe servicios adicionales para el destino del Aeropuerto</p>
		</div>
		</section>

		<!-- dialogo de confirmacion de cantidad -->
		<b-modal
			hide-header
			hide-footer
			ref="refModalForTransportService"
			size="md"
			body-class="p-0">
			<ModalForTransport
				:propViewModel="viewModel"
				:propAddtServiceSelected="selectedAdditionalService"
				:currency = currency
				@confirmQuantity="confirmQuantity"/>
		</b-modal>

		<b-modal
			hide-header
			hide-footer
			ref="refModalForReservation"
			size="md"
			body-class="p-0">
			<ModalForReservation
				:propViewModel="viewModel"
				:propAddtService="selectedAdditionalService"
				:currency = currency
				@confirmQuantity="confirmQuantity"/>
		</b-modal>

		<b-modal
			scrollable
			hide-footer
			ref="refShowDetails"
			size="md"
			title="Detalle del servicio adicional">
			<!-- <TrackingFlightModal
				@closeModal="() => $refs['refTrackingFlight'].hide()"
				/> -->
			<div class="d-flex flex-column w-100" v-if="selectedAddtServiceDetails!=null">
				<b-carousel
					class="shadow-sm"
					id="carousel-1"
					:interval="3000"
					controls
					indicators
					background="#ababab"
					img-width="1024"
					img-height="300"
					style="text-shadow: 1px 1px 2px #333;">
					<!-- Text slides with image -->
					<b-carousel-slide v-for="(item, index) in selectedAddtServiceDetails.content.gallery" :key="index" :img-src="item.url"/>
				</b-carousel>
				<div class="w-100 d-flex text-primary mt-4">
					<md-icon v-if="selectedAddtServiceDetails.relatedTo=='TransportServices'" icon="flight" />
					<md-icon v-else icon="inventory" />

					<h5 class="flex-grow-1 ml-2 card-title">{{selectedAddtServiceDetails.content.name}}</h5>

					<strong class="text-primary mb-1 text-right text-uppercase"><span class="u:text-size-1 font-weight-normal">desde</span> {{selectedAddtServiceDetails.priceCurrency + '$'+extractFirstPrice(selectedAddtServiceDetails.prices)}}</strong>
				</div>
				<p v-html="selectedAddtServiceDetails.content.description"></p>
				<button @click="$refs['refShowDetails'].hide()" class="btn btn-success w-100">Volver</button>
			</div>
		</b-modal>



	</div>
</template>

<script>

// ABREVIATURAS
// Adt = Additional
import CardAdditional from "./CardAdditional.vue";
import ModalForTransport from "./ModalForTransport.vue";
import ModalForReservation from "./ModalForReservation.vue";
import { mapMutations, mapState } from "vuex";

export default {
	props:{
		currency:{type: String, required: true,default: "usd"},
		arrayAdditionalServices:Array
	},
	components: {
		CardAdditional,
		ModalForTransport,
		ModalForReservation,
	},
	data() {
		return {
			getListRides: [],
			// arrayAdditionalServices: [],
			selectedAdditionalService: {},
			selectedAddtServiceDetails: null,
		};
	},
	watch:{
		arrayAdditionalServices(){
			this.checkAddtionalServices();
		}
	},
	computed:{
		...mapState("reservation", ["viewModel"]),
		getListTransportService(){
			return this.viewModel.transportServices;
		},
		_newAdditionalServices(){
			return this.viewModel.additionalServices.filter(item=>{
				return item.id==-1;
			})
		},
	},
	methods: {
		...mapMutations("reservation",
			[
				"SET_NEW_MODEL",
			]
		),
		extractFirstPrice(prices){
			//filtramos los precios mayores a 0,
			// retornamos el precio mas bajo de todo el arreglo
			//usando la funcion math y extraendo los valores con map
			return Math.min.apply(null, prices.filter(opt=>opt.price>0).map(function(item) {
					return item.price;
				}
			))
		},
		showDetails(item){
			this.selectedAddtServiceDetails = item;
			this.$refs['refShowDetails'].show();
		},

		confirmQuantity(newViewModel, type){

			// que tipo de servicio adicional es
			if(type=="TransportServices"){
				//cerramos el modal de confirmacion
				this.$refs['refModalForTransportService'].hide();
			}else{
				//cerramos el modal de confirmacion
				this.$refs['refModalForReservation'].hide();
			}
			//actualizamos el modelo con el nuevo
			this.SET_NEW_MODEL(newViewModel);
			this.checkAddtionalServices();

		},
		checkAddtionalServices(){

			// let aux=JSON.parse(JSON.stringify(this.arrayAdditionalServices))
			//cambiamos el estado del servicio confirmado a seleccionado
			let aux = JSON.parse(JSON.stringify(this._newAdditionalServices));
			this.arrayAdditionalServices.forEach((itemAS)=>{

				let existItem = aux.filter(item=>item.additionalServiceTypeId == itemAS.id);
				if (existItem.length>0){
					itemAS.selected = true;
				}else{
					itemAS.selected = false;
				}

			});

			// this.arrayAdditionalServices = aux;
		},
		selectedAddtService(indexAdtServ) {
			let aux=JSON.parse(JSON.stringify(this.arrayAdditionalServices))
			//recuperamos el item del servicio adicional seleccionado
			this.selectedAdditionalService = aux[indexAdtServ];

			if(this.selectedAdditionalService.relatedTo=="TransportServices"){
				this.$refs['refModalForTransportService'].show();
			}//por defecto es de tipo reservations
			else{
				this.$refs['refModalForReservation'].show();
			}
		},
		changeStatusAdditionalServices(){
			//cambiamos el estado del servicio confirmado a seleccionado
			this.arrayAdditionalServices.forEach(item=>{
				// if(item.id==this.selectedAdditionalService.id){
					item.selected=false
				// }
			});
		},
	},
};
</script>
<style>
.img-fluid {
    max-width: 100%!important;
    height: 300px!important;
    object-fit: contain!important;
}
</style>
